@if (isAllowed$ | async) {
  <router-outlet></router-outlet>
} @else {
  <app-layout [customContent]="true">
    <lib-maintenance-template></lib-maintenance-template>
  </app-layout>
}
